// src/components/StarfieldFX.tsx
import React from 'react'

// deterministic-ish PRNG (varies hourly so the pattern isn’t clockwork)
function prng(n: number) {
  let x = Math.sin(n * 9973) * 43758.5453
  return x - Math.floor(x)
}

// --- twinkles (unchanged) ---
const STARS = Array.from({ length: 28 }, (_, i) => {
  const left = Math.round(prng(i + 1) * 100)
  const top = Math.round(prng(i + 101) * 100)
  const size = 1 + Math.round(prng(i + 201) * 2)
  const delay = (prng(i + 301) * 8).toFixed(2)
  const dur = (4 + prng(i + 401) * 8).toFixed(2)
  return { left, top, size, delay, dur }
})

// --- warp dust (radial from a vanishing point), “grows” from a dot ---
const BASE = 0 // vary hourly
const VPX = 50  // vanishing point X (% of viewport width)
const VPY = 50  // vanishing point Y (% of viewport height) — slightly above center

type Dust = {
  angle: number
  delay: number
  duration: number
  length: number
  thick: number
}

// a teensy bit busier than before
const DUST: Dust[] = Array.from({ length: 7 }, (_, i) => {
  const s = BASE + (i + 1) * 1000
  const angle = Math.round(prng(s + 10) * 360)            // full radial spread
  const delay = 4 + prng(s + 20) * 18                     // 4..22s
  const duration = 9 + prng(s + 30) * 14                  // 9..23s
  const length = 90 + Math.round(prng(s + 40) * 140)      // 90..230px
  const thick  = 1 + Math.round(prng(s + 41) * 1)         // 1..2 px
  return { angle, delay, duration, length, thick }
})

export const StarfieldFX: React.FC = () => (
  <div className="starfield-fx" aria-hidden>
    {/* twinkles */}
    {STARS.map((s, i) => (
      <span
        key={`tw-${i}`}
        className="twinkle"
        style={{
          left: `${s.left}%`,
          top: `${s.top}%`,
          width: `${s.size}px`,
          height: `${s.size}px`,
          animationDelay: `${s.delay}s`,
          animationDuration: `${s.dur}s`,
        }}
      />
    ))}

    {/* warp dust: starts as a point, grows as it flies out */}
    {DUST.map((d, i) => (
      <span
        key={`wd-${i}`}
        className="warp-dust"
        style={{
          // use viewport units so the origin is exact
          left: `${VPX}vw`,
          top:  `${VPY}vh`,
          // no translate(-50%, -50%) — keep the origin at the exact point
          transform: `rotate(${d.angle}deg)`,
        }}
      >
        <i
          style={{
            ['--len' as any]: `${d.length}px`,
            ['--thick' as any]: `${d.thick}px`,
            ['--dur' as any]: `${d.duration}s`,
            ['--delay' as any]: `${d.delay}s`,
          } as React.CSSProperties}
        />
      </span>
    ))}


  </div>
)
